<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50">
    <div class="text-center">
      <h1 class="text-9xl font-bold text-gray-300">404</h1>
      <h2 class="text-3xl font-bold text-gray-900 mb-4">Página não encontrada</h2>
      <p class="text-gray-600 mb-8">A página que você está procurando não existe.</p>
      <router-link to="/" class="btn-primary">
        Voltar ao início
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
